import * as React from 'react';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';

export interface DueDiligenceRequestComponentProps {
  project: Project;
  investment?: Investment;
  enableDueDiligence: () => void;
  visibleDueDiligence: boolean;
  requested: boolean;
  toDownload: boolean;
  notAllowed: boolean;
  requestDueDiligence: () => void;
  download?: () => void;
}

class DueDiligenceComponent extends React.Component<DueDiligenceRequestComponentProps> {

  public render(): React.ReactNode {

    if (this.props.notAllowed) {
      return null;
    }

    if (this.props.toDownload) {
      return (
        <div>
          <p className="text-center">
            <img
              style={{height: '169px'}}
              src={'/img/copy-doc.png'}
              alt={'Due diligence report'}
            />
          </p>
          <div
            className="grey-area text-center pointer"
            style={{
              height: '50px',
              padding: '0'
            }}
            onClick={() => this.props.download!()}
          >
            <img
              width=""
              alt="graphic"
              src="/img/graphic-doc.png"
            />
            <p>
              Descargar Due Diligence
            </p>
          </div>
        </div>
      );
    }

    return (
      <div
        className={(this.props.visibleDueDiligence || this.props.requested) ? '' : 'disabled-due-diligence'}
        onClick={() => this.props.enableDueDiligence()}
      >
        <p className="text-center">
          <img
            style={{height: '169px'}}
            src={'/img/due-diligence.png'}
            alt="due diligence request"
          />
        </p>
        {this.props.requested ?
          <div className="text-center">
            <p className="c-blue">
              <b>Due Diligence Solicitada</b>
            </p>
          </div> :
          <div
            className={this.props.visibleDueDiligence ? 'grey-area text-center pointer' : 'grey-area text-center'}
            style={{
              height: '50px',
              padding: '0'
            }}
            onClick={() => this.props.requestDueDiligence()}
          >
            <p>
              Solicitar la carta de liberación
            </p>
          </div>
        }
      </div>
    );

  }

}

export default DueDiligenceComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/due-diligence/DueDiligence.component.tsx